<ng-template #cellEpoch let-timestamp="timestamp" let-useUtc="useUtc">
  @if (timestamp) {
    <div class="text-ellipsis">
      <div class="text-ellipsis" [title]="timestamp | epoch : 'L' : useUtc">
        {{ timestamp | epoch : 'L' : useUtc }}
      </div>
      <small
        class="text-ellipsis text-gray"
        [title]="timestamp | epoch : 'LT' : useUtc"
        >{{ timestamp | epoch : 'LT' : useUtc }}</small
        >
      </div>
    }
  </ng-template>

  <div class="table-responsive">
    <table
      mat-table
      fixedLayout
      [dataSource]="dataSource"
      matSort
      [tcStickyColumnsEnd]="['actionMenu']"
      (matSortChange)="sortChange.emit($event)"
      matSortDisableClear
      >
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayColumns"
        class="clickable"
        [class.tc-loading-row]="!row"
    [class.tc-green]="
      !row.isExpired && row.is_delivery_date_active && row.isNotSubRow
    "
    [class.tc-red]="
      !row.isExpired && !row.is_delivery_date_active && row.isNotSubRow
    "
      ></tr>

      <ng-container matColumnDef="offer_price">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [title]="columnNames.offer_price"
          >
          {{ columnNames.offer_price }}
        </th>
        <td mat-cell *matCellDef="let row; dataSource: dataSource">
          @if (!row) {
            <div class="skeleton-loader thin-line"></div>
          } @else if (row.isNotSubRow || sorted) { @if (!row['formula']) {
            <div [title]="row.offer_price" class="text-ellipsis">
              {{ row.offer_price | number : '1.4' }}
            </div>
            } @if (row['formula']) {
            <div class="text-ellipsis">
              {{ getSign(row['formula'].lines[0].price) }}
              {{ getAbsolutePrice(row['formula'].lines[0].price) | number : '1.4' }}
            </div>
          }
          <small class="text-gray"
            >{{
            $safeNavigationMigration(row['matchedOffer']?.offer.currency)
            | measure : $safeNavigationMigration(row['matchedOffer']?.offer.weight?.unit)
            }}
            @if (row['formula']) {
              <tc-formula-price
                [formula]="row['formula']"
          [unit]="
            $safeNavigationMigration(row['matchedOffer']?.offer.currency)
              | measure : $safeNavigationMigration(row['matchedOffer']?.offer.weight?.unit)
          "
              ></tc-formula-price>
            }
          </small>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer_price">
      <th
        class="small-column"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [title]="columnNames.buyer_price"
        >
        {{ columnNames.buyer_price }}
      </th>
      <td mat-cell *matCellDef="let row; dataSource: dataSource"
        #td
      [class.tc-cell-editable]="
        row &&
        (row.isNotSubRow || sorted) &&
        (row.matchedOffer?.status === STATUS_PENDING || row.matchedOffer?.status === STATUS_SENT) &&
        !row.isExpired
      "
        (click)="row && inlineMoPriceEdit(row, td)">
        @if (!row) {
          <div class="skeleton-loader thin-line"></div>
        } @else if (row.isNotSubRow || sorted) { @if (!row['buyerFormula']) {
          <span class="text-ellipsis">
            {{ row['buyer_price'] | number : '1.4' }}  </span
            >} @if (row['buyerFormula']) {
            <div class="text-ellipsis">
              {{ getSign($safeNavigationMigration(row['buyerFormula']?.lines[0]?.price)) }}
              {{
              getAbsolutePrice($safeNavigationMigration(row['buyerFormula']?.lines[0]?.price)) | number : '1.4'
              }}
            </div>
          }
          <small class="text-gray"
            >{{
            $safeNavigationMigration(row['matchedOffer']?.bid.currency)
            | measure : $safeNavigationMigration(row['matchedOffer']?.bid.weight?.unit)
            }}
            @if (row['buyerFormula']) {
              <tc-formula-price
                [formula]="row['buyerFormula']"
          [unit]="
            $safeNavigationMigration(row['matchedOffer']?.bid.currency)
              | measure : $safeNavigationMigration(row['matchedOffer']?.bid.weight?.unit)
          "
              ></tc-formula-price>
            }
          </small>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th
        class="small-column"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [title]="columnNames.price"
        >
        {{ columnNames.price }}
      </th>
      <td mat-cell *matCellDef="let row; dataSource: dataSource">
        @if (!row) {
          <div class="skeleton-loader thin-line"></div>
        } @else if (row.isNotSubRow || sorted) { @if (!row['buyerFormula']) {
          <span class="text-ellipsis" [title]="row.price">
            {{ row.price | number : '1.4' }}
          </span>
          } @if (row['buyerFormula']) {
          <div class="text-ellipsis">
            {{ getSign(row.price) }}
            {{ getAbsolutePrice(row.price) | number : '1.4' }}
          </div>
        }
        <small class="text-gray"
          >{{
          $safeNavigationMigration(row['matchedOffer']?.bid.currency)
          | measure : $safeNavigationMigration(row['matchedOffer']?.bid.weight?.unit)
          }}
          @if (row['buyerFormula']) {
            <tc-formula-price
              [formula]="row['buyerFormula']"
          [unit]="
            $safeNavigationMigration(row['matchedOffer']?.bid.currency)
              | measure : $safeNavigationMigration(row['matchedOffer']?.bid.weight?.unit)
          "
              [price]="row.price"
            ></tc-formula-price>
          }
        </small>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="fob_price">
    <th
      class="small-column"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      [title]="columnNames.fob_price"
      >
      {{ columnNames.fob_price }}
    </th>
    <td mat-cell *matCellDef="let row; dataSource: dataSource">
      @if (!row) {
        <div class="skeleton-loader thin-line"></div>
      } @else if (row.isNotSubRow || sorted) { @if (!row['buyerFormula']) {
        <span class="text-ellipsis">
          {{ row['fob_price'] | number : '1.4' }}
        </span>
        } @if (row['buyerFormula']) {
        <div class="text-ellipsis">
          {{ getSign(row['fob_price']) }}
          {{ getAbsolutePrice(row['fob_price']) | number : '1.4' }}
        </div>
      }
      <small class="text-gray"
        >{{
        $safeNavigationMigration(row['matchedOffer']?.offer.currency)
        | measure : $safeNavigationMigration(row['matchedOffer']?.offer.weight?.unit)
        }}
        @if (row['buyerFormula']) {
          <tc-formula-price
            [formula]="row['buyerFormula']"
          [unit]="
            $safeNavigationMigration(row['matchedOffer']?.offer.currency)
              | measure : $safeNavigationMigration(row['matchedOffer']?.offer.weight?.unit)
          "
            [price]="row['fob_price']"
          ></tc-formula-price>
        }
      </small>
    }
  </td>
</ng-container>

<ng-container matColumnDef="bidPartialMargin">
  <th
    class="small-column"
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.bidPartialMargin"
    >
    {{ columnNames.bidPartialMargin }}
  </th>
  <td mat-cell *matCellDef="let row; dataSource: dataSource" >
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div [class.text-red]="row.bidding?.isBiggestBidPartialMargin">
        <div class="text-ellipsis">{{$safeNavigationMigration(row.bidding?.bidPartialMargin) | number:'1.2-2'}}%</div>
        <small class="text-gray">
          <span>{{ $safeNavigationMigration(row.bidding?.bidPartialMarginCad) | currencyFormat:'CAD' }}</span>
        </small>
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="status">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.status"
    >
    {{ columnNames.status }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row || sorted) {
      <div class="text-ellipsis">
        @if (row.isNotSubRow) {
          <tc-future-bid-status
            [status]="row.status"
            [dealStatus]="row.deal_status"
          ></tc-future-bid-status>
        } @else {
          <tc-future-bid-status
            [status]="$safeNavigationMigration(row.matched_offers[0]?.status)"
            [dealStatus]="row.deal_status"
          ></tc-future-bid-status>
        }
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="matched_offer_id">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.matched_offer_id"
    >
    {{ columnNames.matched_offer_id }}
  </th>
  <td mat-cell *matCellDef="let row; dataSource: dataSource">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <button class="btn-link" type="button"
        [title]="row.matched_offer_id | fakeId:'OFFER-'"
        (click)="showMatchedOfferDialog(row.matchedOffer)"
        >{{row.matched_offer_id | fakeId:'OFFER-'}}
      </button>
    }
  </td>
</ng-container>

<ng-container matColumnDef="deal_id">
  <th mat-header-cell *matHeaderCellDef mat-sort-header [title]="columnNames.deal_id">{{columnNames.deal_id}}</th>
  <td mat-cell *matCellDef="let row; dataSource:dataSource">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else {
      @if (row.deal_id || sorted) {
        <a class="text-ellipsis" [title]="row.deal_id"
          [routerLink]="getDealUrl | call:row.deal_id"
          target="_blank">
          {{row.deal_id}}
        </a>
      } @else if (!row.isExpired && row.isNotSubRow && row.inventory_deal_id) {
        <a class="text-ellipsis" [title]="row.inventory_deal_id"
          [routerLink]="getDealUrl | call:row.inventory_deal_id"
          target="_blank">
          {{row.inventory_deal_id}}
        </a>
      }
    }
  </td>
  <td mat-footer-cell *matFooterCellDef></td>
</ng-container>

<ng-container matColumnDef="buyerName">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.buyerName"
    >
    {{ columnNames.buyerName }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="row.buyerName">
        {{ row.buyerName }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="supplierName">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.supplierName"
    >
    {{ columnNames.supplierName }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="row.supplierName">
        {{ row.supplierName }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="productName">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.productName"
    >
    {{ columnNames.productName }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="row.productName">
        {{ row.productName }}
      </div>
    }
  </td>
</ng-container>

<!-- sorting is intentionally disabled for Product + (client-computed value) -->
<ng-container matColumnDef="productPlus">
  <th
    mat-header-cell
    *matHeaderCellDef
    [title]="columnNames.productPlus"
    >
    {{ columnNames.productPlus }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="getProductPlus(row)">
        {{ getProductPlus(row) }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="productSpecification">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.productSpecification"
    >
    {{ columnNames.productSpecification }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="row.productSpecification">
        {{ row.productSpecification }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="futureDates">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.futureDates"
    >
    {{ columnNames.futureDates }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else {
      <div
        [ngStyle]="{
          'text-decoration':
            !row.is_delivery_date_active && row.isNotSubRow && 'line-through'
        }"
        class="text-ellipsis"
        [title]="row.futureDates | epochRange : true"
        >
        {{ row.futureDates | epochRange : true }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="shipmentDates">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.shipmentDates"
    >
    {{ columnNames.shipmentDates }}
  </th>
  <td mat-cell *matCellDef="let row; dataSource: dataSource">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else {
      <div
      [ngStyle]="{
        'text-decoration':
          !row.is_delivery_date_active && row.isNotSubRow && 'line-through'
        }"
        class="text-ellipsis"
        [title]="row.shipmentDates | epochRange : true"
        >
        {{ row.shipmentDates | epochRange : true }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="created">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.created"
    >
    {{ columnNames.created }}
  </th>
  <td mat-cell *matCellDef="let row; dataSource: dataSource">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
      <div class="skeleton-loader tiny-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <ng-container
        *ngTemplateOutlet="cellEpoch; context: { timestamp: row.created, useUtc: true }"
      ></ng-container>
    }
  </td>
  <td mat-footer-cell *matFooterCellDef></td>
</ng-container>

<ng-container matColumnDef="updated">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.updated"
    >
    {{ columnNames.updated }}
  </th>
  <td mat-cell *matCellDef="let row; dataSource: dataSource">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
      <div class="skeleton-loader tiny-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <ng-container
        *ngTemplateOutlet="cellEpoch; context: { timestamp: row.updated, useUtc: true }"
      ></ng-container>
    }
  </td>
  <td mat-footer-cell *matFooterCellDef></td>
</ng-container>

<ng-container matColumnDef="deliveryLocation">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.deliveryLocation"
    >
    {{ columnNames.deliveryLocation }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="row.deliveryLocation">
        {{ row.deliveryLocation }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="pickupLocation">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    [title]="columnNames.pickupLocation"
    >
    {{ columnNames.pickupLocation }}
  </th>
  <td mat-cell *matCellDef="let row">
    @if (!row) {
      <div class="skeleton-loader thin-line"></div>
    } @else if (row.isNotSubRow || sorted) {
      <div class="text-ellipsis" [title]="row.pickupLocation">
        {{ row.pickupLocation }}
      </div>
    }
  </td>
</ng-container>

<ng-container matColumnDef="actionMenu">
  <th mat-header-cell *matHeaderCellDef>
    @if (showColumnSettings) {
      <button mat-icon-button type="button" (click)="editColumns.next()">
        <mat-icon class="fas fa-bars"></mat-icon>
      </button>
    }
  </th>
  <td mat-cell *matCellDef="let row; dataSource: dataSource">
    @if (!row) {
      <div class="skeleton-loader circle"></div>
    } @else {
      <button
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="actionMenu"
        [matMenuTriggerData]="{ row: row }"
        >
        <mat-icon class="fa fa-ellipsis-v"></mat-icon>
      </button>
    }
  </td>
  <td mat-footer-cell *matFooterCellDef></td>
</ng-container>
</table>

<mat-menu #actionMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-row="row">
    @if (!row.isExpired && row.is_delivery_date_active && row.isNotSubRow) {
      <button mat-menu-item (click)="confirmBid(row)">
        <i class="fa fa-fw fa-check"></i> Confirm Bid
      </button>
    }
    @if (canAssignToInvDeal(row)) {
      <button mat-menu-item (click)="assignToCurrentOfferInvDeal(row)">
        <i class="fa fa-fw fa-link"></i>
        Assign to CO's Inv Deal
      </button>
    }
    @if (!row.isNotSubRow) {
      @if (!row.supplier_offers?.[0] || isExpired($safeNavigationMigration(row.supplier_offers?.[0]))) {
        <button
          mat-menu-item
          (click)="addOfferOverlay(row)"
          >
          <i class="fa fa-fw fa-edit"></i>
          Create Offer
        </button>
      }
    }
    @if (row.supplier_offers?.length > 0) {
      <button
        mat-menu-item
        (click)="showSupplierOffer($safeNavigationMigration(row.supplier_offers?.[0]?.offer_id))"
        >
        <i class="fa fa-fw fa-eye"></i>
        View Supplier Offer
      </button>
    }
    @if (row.matched_offers?.length > 0) {
      <button
        mat-menu-item
        (click)="showMatchedOffer($safeNavigationMigration(row.supplier_offers?.[0]?.offer_id))"
        >
        <i class="fa fa-fw fa-eye"></i>
        View Matched Offer
      </button>
    }
    @if (row.isNotSubRow && hasPendingFutureBidMo(row)) {
      <button
        mat-menu-item
        (click)="viewAllMatchedOffers(row)"
        >
        <i class="fa fa-fw fa-list"></i>
        View All Matched Offers
      </button>
    }
    <button mat-menu-item (click)="createDeal(row)">
      <i class="fa fa-fw fa-edit"></i>
      Create Deal
    </button>
    <button mat-menu-item (click)="searchInventory(row)">
      <i class="fa fa-fw fa-search"></i>
      Search Inventory
    </button>
    <button mat-menu-item (click)="showCompanyCredit(row)">
      <i class="fa fa-fw fa-money-bill-1"></i>
      Check Credit
    </button>
  </ng-template>
</mat-menu>
</div>
<tc-inline-editor #inlineEditor></tc-inline-editor>
@if (showPaginator) {
  <mat-paginator #paginator></mat-paginator>
}
